module.exports = __webpack_public_path__ + "static/media/selesai-studi.99bc485b.svg";